var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import "element-internals-polyfill";
import { property } from "lit/decorators.js";
import { OmniElement } from "./omni-element.js";
class ElementInternalsBase extends OmniElement {
  constructor() {
    super(...arguments);
    this.disabled = false;
    this.required = false;
    /** @internal */
    this._internals = this.attachInternals();
  }
  static get formAssociated() {
    return true;
  }
  connectedCallback() {
    super.connectedCallback();
    this.tabIndex = !this.disabled ? 0 : -1;
  }
  /** check the form input for client-side validation, if false fire invalid event and send the `validationMessage` to the user agent to handle */
  reportValidity() {
    return this._internals.reportValidity();
  }
  /** check the form input for client-side validation, if false fire invalid event */
  checkValidity() {
    return this._internals.checkValidity();
  }
  /** readonly */
  get valid() {
    return this._internals.checkValidity();
  }
}
__decorateClass([
  property({ type: Boolean, reflect: true })
], ElementInternalsBase.prototype, "disabled", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], ElementInternalsBase.prototype, "required", 2);
export {
  ElementInternalsBase
};
//# sourceMappingURL=element-internals-base.js.map
